<template>
  <div>
    <v-card class="pb-2">
      <v-toolbar dense flat class="body-2 beez-bold">
        Variables
        <v-spacer />
        <v-btn flat icon @click="addVariableItem">
          <v-icon>
            add
          </v-icon>
        </v-btn>
        <v-btn flat icon @click="showPreview = !showPreview">
          <v-icon>
            remove_red_eye
          </v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-layout row>
          <v-flex :xs4="showInputForm === true" :xs12="showInputForm === false">
            <v-card>
              <v-toolbar flat dense class="body-2 beez-bold">
                Variable List
              </v-toolbar>
              <v-card-text>
                <v-list two-line>
                  <v-list-tile v-if="variables.length <= 0">
                    <v-list-tile-content>
                      <v-list-tile-title>
                        No Variables added, Please click
                        <v-icon>add</v-icon>
                        to add a variable
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <template v-for="(item, index) in variables">
                    <v-list-tile
                      :key="item.name + index"
                      @click="selectItem(item)"
                    >
                      <v-list-tile-content>
                        <v-list-tile-title v-html="item.name" />
                        <v-list-tile-sub-title v-html="item.type" />
                      </v-list-tile-content>
                      <v-list-tile-action @click.stop="removeItem(item)">
                        <v-icon>
                          delete
                        </v-icon>
                      </v-list-tile-action>
                    </v-list-tile>
                    <v-divider :key="item.name + index + 'divider'" />
                  </template>
                </v-list>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex :xs8="showInputForm === true">
            <v-flex class="pl-3" v-if="showInputForm">
              <v-form
                ref="variableForm"
                v-model="validForm"
                :class="$vuetify.dark ? 'card-dark ' : 'card-light '"
              >
                <v-toolbar dense flat>
                  Add new variable
                  <v-spacer />
                  <v-btn flat icon @click="showInputForm = false">
                    <v-icon>
                      close
                    </v-icon>
                  </v-btn>
                </v-toolbar>
                <v-container>
                  <v-layout row>
                    <v-flex grow>
                      <v-text-field
                        v-model="variable.name"
                        :rules="variable.nameRules"
                        label="Variable name"
                        required
                      />
                      <v-switch
                        v-model="variable.flowVariable"
                        label="Add to workflow"
                      />
                      <v-select
                        :items="variableTypes"
                        label="Variable type"
                        :outline="$vuetify.dark"
                        v-model="variable.type"
                        :rules="variable.typeRules"
                        @change="setInitialValue"
                      />
                      <v-text-field
                        v-if="variable.type === 'STRING'"
                        v-model="variable.value"
                        :rules="variable.valueRules"
                        label="Variable value"
                        required
                      />
                      <v-flex
                        v-else-if="
                          variable.type === 'OBJECT' ||
                            variable.type === 'ARRAY'
                        "
                      >
                        <v-flex xs12>
                          <v-jsoneditor
                            v-model="variable.value"
                            :options="jsonOptions"
                            height="400px"
                            :plus="true"
                            key="jsonEditor"
                          >
                          </v-jsoneditor>
                        </v-flex>
                      </v-flex>
                      <v-btn
                        flat
                        @click="validate"
                        :class="
                          !$vuetify.dark
                            ? 'secondary text-capitalize'
                            : 'text-capitalize'
                        "
                        :color="$vuetify.dark ? 'secondary' : ''"
                        :outline="$vuetify.dark"
                      >
                        Submit
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-flex>
          </v-flex>
        </v-layout>
        <v-layout row class="pt-3" v-if="showPreview">
          <v-flex xs12>
            <v-card>
              <v-toolbar dense flat class="body-2 beez-bold">
                Preview
              </v-toolbar>
              <v-card-text>
                <form-generator
                  :key="variables.length + '-generator-variable-appender'"
                  :schema="screenSchema"
                  :readonly="true"
                />
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-btn
          flat
          :class="!$vuetify.dark ? 'secondary' : ''"
          :color="$vuetify.dark ? 'secondary' : ''"
          :outline="$vuetify.dark"
          @click="handleSubmit"
          :loading="submitLoader"
        >
          Submit
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import FormGenerator from '../common/form-generator/FormGenerator'
import _ from 'lodash'

export default {
  name: 'ExecutionVariableAppender',
  components: {
    FormGenerator
  },
  props: {
    submitLoader: {
      default: false,
      type: Boolean
    }
  },
  data: function() {
    return {
      showInputForm: false,
      showPreview: false,
      jsonOptions: { mode: 'code' },
      validForm: false,
      variableTypes: ['STRING', 'OBJECT', 'ARRAY'],
      variables: [],
      variable: {
        name: '',
        nameRules: [v => !!v || 'Variable name is required'],
        type: '',
        typeRules: [v => !!v || 'Please select a variable type'],
        value: null,
        valueRules: [v => !!v || 'Variable value is required']
      }
    }
  },
  computed: {
    screenSchema: {
      get: function() {
        let screenSchema = []
        this.variables.forEach(item => {
          screenSchema.push({
            key: item.name,
            type: this.getFormType(item),
            options: {
              label: item.name,
              value: item.value
            }
          })
        })

        return screenSchema
      }
    }
  },
  methods: {
    getFormType(variable) {
      //  STRING, NUMBER, BOOLEAN, OBJECT, DATE, FILE, ARRAY - possible input options
      if (_.isArray(variable.value)) {
        return 'array'
      } else if (_.isString(variable.value)) {
        switch (variable.type) {
          case 'STRING':
            return 'text'
          case 'NUMBER':
            return 'text'
          case 'BOOLEAN':
            return 'checkbox'
          case 'DATE':
            return 'date'
          case 'FILE':
            return 'file'
          default:
            return 'text'
        }
      } else if (_.isDate(variable.value)) {
        return 'date'
      } else if (_.isNumber(variable.value)) {
        return 'text'
      } else if (_.isBoolean(variable.value)) {
        return 'checkbox'
      } else if (_.isUndefined(variable.value)) {
        return 'text'
      } else if (_.isNull(variable.value)) {
        return 'text'
      } else if (_.isObject(variable.value)) {
        return 'object'
      }
    },
    setInitialValue() {
      if (this.variable.type === 'STRING') {
        this.variable.value = ''
      } else if (this.variable.type === 'OBJECT') {
        this.variable.value = {}
      } else if (this.variable.type === 'ARRAY') {
        this.variable.value = []
      }
    },
    removeItem(item) {
      this.variables = this.variables.filter(i => i !== item)
    },
    selectItem(item) {
      this.variable.name = item.name
      this.variable.value = item.value
      this.variable.type = item.type
      this.variable.flowVariable = item.flowVariable
      this.showInputForm = true
    },
    addVariableItem() {
      this.variable.name = ''
      this.variable.value = ''
      this.variable.type = 'STRING'
      this.variable.flowVariable = false
      this.showInputForm = true
    },
    validate() {
      if (this.$refs.variableForm.validate()) {
        this.variables.push(this.variable)
        this.showInputForm = false
      }
    },
    handleSubmit() {
      let input = {}
      this.variables.forEach(item => {
        input[item.name] = {
          value: item.value,
          type: item.type,
          flowVariable: item.flowVariable
        }
      })
      this.$emit('submit', input)
    }
  }
}
</script>

<style scoped></style>
